import type { FinanceKey } from './keys';

export const nl: Partial<Record<FinanceKey, string>> = {
  'panel.params': 'Parameters',
  'panel.advanced': 'Geavanceerd',
  'panel.experiment': 'Experiment',
  'action.reset': 'Herstellen',
  'action.randomise': 'Willekeurig',
  'experiment.compound-interest.label': 'Samengestelde rente',
  'experiment.compound-interest.info':
    'Vergelijk de groei van samengestelde en enkelvoudige rente in de tijd.',
  'experiment.power-of-time.label': 'Kracht van tijd',
  'experiment.power-of-time.info':
    'Zie hoe vroeg beginnen laat beginnen verslaat, ook met minder geld.',
  'experiment.savings-goal.label': 'Spaardoel',
  'experiment.savings-goal.info':
    'Bereken hoeveel je maandelijks moet sparen om een doel te bereiken.',
  'experiment.borrowing-cost.label': 'Leenkosten',
  'experiment.borrowing-cost.info': 'Verken de werkelijke kosten van leningen en creditcards.',
  'experiment.inflation.label': 'Inflatie',
  'experiment.inflation.info': 'Zie hoe koopkracht in de loop van de tijd afneemt.',
  'experiment.fees-drag.label': 'Kosteneffect',
  'experiment.fees-drag.info':
    'Ontdek hoe kleine jaarlijkse kosten samengesteld grote verliezen worden.',
  /* compound-interest */
  'param.principal.label': 'Startkapitaal',
  'param.rate.label': 'Jaarlijks rentepercentage',
  'param.years.label': 'Jaren',
  'param.showSimple.label': 'Toon enkelvoudige rente',
  'param.frequency.label': 'Samenstellingsfrequentie',
  'param.frequency.annual': 'Jaarlijks',
  'param.frequency.biannual': 'Twee keer per jaar',
  'param.frequency.quarterly': 'Kwartaal',
  'param.frequency.monthly': 'Maandelijks',
  'param.frequency.daily': 'Dagelijks',
  'stat.final-compound.label': 'Eindwaarde samengesteld',
  'stat.final-simple.label': 'Eindwaarde enkelvoudig',
  'stat.gap.label': 'Verschil (samengesteld − enkelvoudig)',
  'series.compound.label': 'Samengesteld',
  'series.simple.label': 'Enkelvoudig',
  'preset.starter.label': 'Starter',
  'preset.decades.label': 'Decennia',
  'preset.high-rate.label': 'Hoge rente',
  /* power-of-time */
  'param.monthly.label': 'Maandelijkse inleg',
  'param.horizon.label': 'Horizon (jaren)',
  'param.a-start.label': 'Spaarder A start',
  'param.a-stop.label': 'Spaarder A stop',
  'param.b-start.label': 'Spaarder B start',
  'param.b-stop.label': 'Spaarder B stop',
  'stat.a-contributed.label': 'A ingelegd',
  'stat.a-final.label': 'Eindsaldo A',
  'stat.b-contributed.label': 'B ingelegd',
  'stat.b-final.label': 'Eindsaldo B',
  'stat.doubling.label': 'Verdubbelingstijd (jr)',
  'stat.cost-of-waiting.label': 'Kosten van wachten',
  'series.saver-a.label': 'Spaarder A (vroeg)',
  'series.saver-b.label': 'Spaarder B (laat)',
  'preset.classic-early-vs-late.label': 'Klassiek vroeg vs laat',
  'preset.same-total.label': 'Zelfde totaal belegd',
  'preset.late-bloomer.label': 'Laat beginnen',
  /* savings-goal */
  'param.target.label': 'Spaardoel',
  'param.goalSeek.label': 'Doelzoekmodus',
  'stat.total-contributed.label': 'Totaal ingelegd',
  'stat.total-growth.label': 'Totale groei',
  'stat.final-balance.label': 'Eindsaldo',
  'stat.required-monthly.label': 'Vereiste maandelijkse inleg',
  'series.contributions.label': 'Inleg',
  'series.growth.label': 'Groei',
  'series.goal.label': 'Doel',
  'preset.emergency-fund.label': 'Noodfonds',
  'preset.house-deposit.label': 'Hypotheekaanbetaling',
  'preset.gap-year.label': 'Sabbatsjaar',
  /* borrowing-cost */
  'param.amount.label': 'Leenbedrag',
  'param.apr.label': 'Jaarlijks rentepercentage (APR)',
  'param.mode.label': 'Terugbetalingsmodus',
  'param.mode.amortizing': 'Aflossingslening',
  'param.mode.credit-card': 'Creditcard minimum',
  'param.minRate.label': 'Minimale betalingsratio',
  'param.extra.label': 'Extra betaling/maand',
  'stat.monthly-payment.label': 'Maandelijkse betaling',
  'stat.total-paid.label': 'Totaal betaald',
  'stat.total-interest.label': 'Totale rente',
  'stat.payoff-years.label': 'Aflossingsduur (jr)',
  'stat.interest-saved.label': 'Rente bespaard',
  'stat.years-saved.label': 'Jaren bespaard',
  'series.interest.label': 'Cumulatieve rente',
  'series.principal.label': 'Cumulatieve aflossing',
  'series.balance.label': 'Resterende schuld',
  'preset.car-loan.label': 'Autolening',
  'preset.mortgage.label': 'Hypotheek',
  'preset.credit-card-trap.label': 'Creditcardval',
  /* inflation */
  'param.start-amount.label': 'Bedrag',
  'param.inflation.label': 'Inflatiepercentage',
  'param.savingsRate.label': 'Spaarrente',
  'param.compareSavings.label': 'Vergelijk spaarrekening',
  'stat.real-value.label': 'Reële waarde na jaren',
  'stat.real-return.label': 'Reëel rendement',
  'stat.break-even.label': 'Break-even rente',
  'stat.losing-ground.label': 'Reëel verlies',
  'series.nominal.label': 'Nominaal (contant)',
  'series.real.label': 'Reële waarde',
  'series.savings.label': 'Spaargeld (nominaal)',
  'series.savings-real.label': 'Spaargeld (reëel)',
  'preset.cash-under-mattress.label': 'Contant onder de matras',
  'preset.low-savings-rate.label': 'Lage spaarrente',
  'preset.beats-inflation.label': 'Verslaat inflatie',
  /* fees-drag */
  'param.fee.label': 'Jaarlijkse kosten',
  'stat.final-no-fee.label': 'Eindwaarde zonder kosten',
  'stat.final-with-fee.label': 'Eindwaarde met kosten',
  'stat.fee-cost.label': 'Totale kostenimpact',
  'stat.fee-cost-pct.label': 'Kosten (% van pot)',
  'stat.fee-comp-low.label': 'Kosten bij 0,2% tarief',
  'stat.fee-comp-typical.label': 'Kosten bij 1% tarief',
  'stat.fee-comp-high.label': 'Kosten bij 2% tarief',
  'series.no-fee.label': 'Zonder kosten',
  'series.with-fee.label': 'Met kosten',
  'series.fee-gap.label': 'Kostenverschil',
  'preset.low-fee.label': 'Lage kosten (0,2%)',
  'preset.typical-fee.label': 'Gemiddelde kosten (1%)',
  'preset.high-fee.label': 'Hoge kosten (2%)',
};
